// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__HGaBo","modal":"Modal_modal__27O6c","slide-down":"Modal_slide-down__2wqN3"};